import { IntelligenceShell } from '../components/IntelligenceShell';

/** Placeholder for Sprint 2+ modules — no backend, no separate pages yet. */
export default function IntelligencePlaceholderPage() {
  return (
    <IntelligenceShell>
      <div className="flex flex-col items-center justify-center min-h-80 gap-4 rounded-2xl border border-dashed border-gray-200 bg-white">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-teal-50">
          <i className="ri-hammer-line text-3xl text-teal-500" />
        </div>
        <div className="text-center">
          <h2 className="text-base font-bold text-gray-900">قادم في مرحلة لاحقة</h2>
          <p className="text-sm text-gray-500 mt-1 max-w-sm">هذه الوحدة محجوزة ضمن بنية الذكاء التجاري وسيتم ربطها بالخادم قريبًا.</p>
        </div>
      </div>
    </IntelligenceShell>
  );
}
